import './App.css'
import React, { useState, useEffect } from 'react'
import { LanguageProvider } from './LanguageContext'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import Login from './components/Login'
import ProfilePage from './components/ProfilePage'
import Header from './components/Header'
import Fireworks from './components/Fireworks'
import CartPage from './components/CartPage'
import CheckoutPage from './components/CheckoutPage'
import ManageUsers from './components/ManageUsers'
import Orders from './components/Orders'
import PhoneAuth from './components/SMS'
import SubscribeButton from './components/subsrcibe'
import HomePage from './components/HomePage'
import Categories from './components/Categories'
import InviteCodes from './components/InviteCodesPage'
import Discounts from './components/Discounts'
import ChangePassword from './components/ChangePassword'
import Overlay from './components/Modal'
import { BACKEND_URI } from './config'

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'

function App() {
  const [user, setUser] = useState(() =>
    JSON.parse(localStorage.getItem('user'))
  )
  const [cartItems, setCartItems] = useState([])
  const [FundstoAdd, setFundstoAdd] = useState(0)
  const [useFunds, setuseFunds] = useState(false)
  const [orderType, setorderType] = useState()
  const [orderID, setorderID] = useState()
  const [isPickup, setIsPickup] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [items, setItems] = useState([])
  const [enlargedGifLink, setenlargedGifLink] = useState()
  const [enlargedLinkType, setEnlargedLinkType] = useState('gif')
  const [categoryReturn, setCategoryReturn] = useState('assortments')
  const [fireworkScrollY, setFireworkScrollY] = useState(0)
  const [backgroundPosition, setBackgroundPosition] = useState('0%')

  const checkTokenValidity = async () => {
    const token = localStorage.getItem('token')

    console.log('checked')

    if (!token) {
      handleLogout()
      return
    }

    try {
      const response = await fetch(`${BACKEND_URI}/api/verify-token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Include JWT in the Authorization header
        },
      })

      if (!response.ok) {
        handleLogout()
      }
    } catch (error) {
      console.error('Token validation failed:', error)
      handleLogout()
    }
  }

  useEffect(() => {
    // checkTokenValidity();

    // Set interval to check token every minute
    const interval = setInterval(() => {
      const token = localStorage.getItem('token')
      if (token) checkTokenValidity()
    }, 3000000) // Every 300 seconds

    return () => clearInterval(interval) // Cleanup interval on unmount
  }, [])

  const handleLogin = token => {
    localStorage.setItem('token', JSON.stringify(token))
    retrieveUser()
    fetchCartFromDatabase()
  }

  const handleLogout = () => {
    // localStorage.removeItem("user");
    localStorage.removeItem('token')
    setUser(null) // Clear user data on logout
  }

  const retrieveUser = async () => {
    const token = localStorage.getItem('token') // Get JWT from localStorage

    if (token !== null) {
      try {
        const response = await fetch(`${BACKEND_URI}/api/getuser`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, // Include JWT in the Authorization header
          },
        })

        const data = await response.json()
        setUser(data.user)

        if (!response.ok) {
          handleLogout()
        }
      } catch (error) {
        console.log(error)
        handleLogout()
      }
    }
  }

  const fetchCartFromDatabase = async () => {
    try {
      const token = localStorage.getItem('token') // JWT from localStorage
      const response = await fetch(`${BACKEND_URI}/api/get-cart`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Include JWT
        },
      })

      if (!response.ok) {
        throw new Error('Failed to fetch cart from database')
      }

      const data = await response.json()
      setCartItems(data.cart || []) // Load cart items into state
    } catch (err) {
      console.error('Error fetching cart from database:', err)
    }
  }

  return (
    <Router>
      <LanguageProvider>
        <div>
          {user && <Header user={user} cartItems={cartItems} />}
          {user && <Categories onLogout={handleLogout} setItems={setItems} />}
          <ToastContainer
            position='bottom-right'
            autoClose={5000}
            hideProgressBar={false}
          />
          <Routes>
            <Route
              path='/'
              element={
                !user ? (
                  <Login
                    onLogin={handleLogin}
                    phonenumber={phoneNumber}
                    setPhoneNumber={setPhoneNumber}
                  />
                ) : (
                  <Navigate to='/homepage' />
                )
              }
            />
            <Route
              path='/homepage'
              element={user ? <HomePage /> : <Navigate to='/' />}
            />
            <Route
              path='/fireworks'
              element={
                user ? (
                  <Fireworks
                    user={user}
                    setCartItems={setCartItems}
                    onLogout={handleLogout}
                    items={items}
                    setItems={setItems}
                    setEnlargedGifLink={setenlargedGifLink}
                    setEnlargedLinkType={setEnlargedLinkType}
                    setCategoryReturn={setCategoryReturn}
                    fireworkScrollY={fireworkScrollY}
                    setFireworkScrollY={setFireworkScrollY}
                    backgroundPosition={backgroundPosition}
                    setBackgroundPosition={setBackgroundPosition}
                  />
                ) : (
                  <Navigate to='/' />
                )
              }
            />
            <Route
              path='/fireworks/:category'
              element={
                user ? (
                  <Fireworks
                    user={user}
                    setCartItems={setCartItems}
                    onLogout={handleLogout}
                    items={items}
                    setItems={setItems}
                    setEnlargedGifLink={setenlargedGifLink}
                    setEnlargedLinkType={setEnlargedLinkType}
                    setCategoryReturn={setCategoryReturn}
                    fireworkScrollY={fireworkScrollY}
                    setFireworkScrollY={setFireworkScrollY}
                    backgroundPosition={backgroundPosition}
                    setBackgroundPosition={setBackgroundPosition}
                  />
                ) : (
                  <Navigate to='/' />
                )
              }
            />
            <Route
              path='/fireworks-enlarged'
              element={
                user ? (
                  <Overlay enlargedLinkType={enlargedLinkType}
                           enlargedGifLink={enlargedGifLink}
                           categoryReturn={categoryReturn}
                           backgroundPosition={backgroundPosition}/>
                ) : (
                  <Navigate to='/' />
                )
              }
            />
            <Route
              path='/change-password/:token'
              element={<ChangePassword />}
            />
            <Route
              path='/profile'
              element={
                user ? (
                  <ProfilePage
                    user={user}
                    onLogout={handleLogout}
                    FundstoAdd={FundstoAdd}
                    setFundstoAdd={setFundstoAdd}
                    setorderType={setorderType}
                  />
                ) : (
                  <Navigate to='/' />
                )
              }
            />
            <Route
              path='/manageusers'
              element={
                user && user.admin ? (
                  <ManageUsers user={user} />
                ) : (
                  <Navigate to='/' />
                )
              }
            />
            <Route
              path='/manageInviteCodes'
              element={
                user && user.admin ? <InviteCodes user={user}/> : <Navigate to='/' />
              }
            />
            <Route
              path='/managediscounts'
              element={user && user.admin ? <Discounts /> : <Navigate to='/' />}
            />
            <Route
              path='/orders'
              element={
                user ? (
                  <Orders
                    user={user}
                    setorderType={setorderType}
                    setorderID={setorderID}
                    useFunds={useFunds}
                    setuseFunds={setuseFunds}
                    setIsPickup={setIsPickup}
                    isPickup={isPickup}
                  />
                ) : (
                  <Navigate to='/' />
                )
              }
            />
            <Route
              path='/cart'
              element={
                user ? (
                  <CartPage
                    user={user}
                    cartItems={cartItems}
                    setCartItems={setCartItems}
                    useFunds={useFunds}
                    setuseFunds={setuseFunds}
                    setorderType={setorderType}
                    setIsPickup={setIsPickup}
                    isPickup={isPickup}
                  />
                ) : (
                  <Navigate to='/' />
                )
              }
            />
            <Route
              path='/sms-verify'
              element={
                phoneNumber ? (
                  <PhoneAuth phoneNumber={phoneNumber} />
                ) : (
                  <Navigate to='/' />
                )
              }
            />
            <Route
              path='/checkout'
              element={
                user ? (
                  <CheckoutPage
                    FundstoAdd={FundstoAdd}
                    setCartItems={setCartItems}
                    useFunds={useFunds}
                    orderType={orderType}
                    orderID={orderID}
                    isPickup={isPickup}
                  />
                ) : (
                  <Navigate to='/' />
                )
              }
            />
            <Route
              path='/subscribe'
              element={user ? <SubscribeButton /> : <Navigate to='/' />}
            />
          </Routes>
        </div>
      </LanguageProvider>
    </Router>
  )
}

export default App
